module.exports = __webpack_public_path__ + "img/prep.1f1b28c5.gif";